export default class OrderStatus {
  constructor({ id = null, name = '', color = '' } = {}) {
    this.id = id;
    this.name = name;
    this.color = color;
  }
}



// WEBPACK FOOTER //
// ./src/models/OrderStatus.js